import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ConfiguracionComisionModel } from 'src/app/core/models/configuracion-comision.model';
import { Injectable } from '@angular/core';
import { TarifarioResponse } from 'src/app/core/models/response/tarifario.response';
import { TarifarioService } from 'src/app/core/services/tarifario.service';

@Injectable()
export class SubscripcionesResolver implements Resolve<TarifarioResponse[]> {
  constructor(private tarifarioService: TarifarioService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<TarifarioResponse[]> {
    return this.tarifarioService.getSubscripciones();
  }
}
